import React from 'react';
import { ChevronRight } from 'lucide-react';
import './DeviceInventoryCard.css';

interface DeviceInventoryCardProps {
  title: string;
  icon: React.ReactNode;
  description: string;
  selectedCount: number;
  totalAvailable: number;
  maxSelection?: number;
  onClick: () => void;
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'info';
}

const DeviceInventoryCard: React.FC<DeviceInventoryCardProps> = ({
  title,
  icon,
  description,
  selectedCount,
  totalAvailable,
  maxSelection,
  onClick,
  variant = 'primary'
}) => {
  const hasSelection = selectedCount > 0;
  const isMaxed = maxSelection !== undefined && selectedCount >= maxSelection;

  return (
    <div 
      className={`device-inventory-card device-inventory-card-${variant} ${hasSelection ? 'has-selection' : ''}`}
      onClick={onClick}
    >
      <div className="device-inventory-card-header">
        <div className="device-inventory-card-icon-wrapper">
          <div className={`device-inventory-card-icon device-inventory-card-icon-${variant}`}>
            {icon}
          </div>
        </div>
        <div className="device-inventory-card-content">
          <h4 className="device-inventory-card-title">{title}</h4>
          <p className="device-inventory-card-description">{description}</p>
        </div>
        <div className="device-inventory-card-arrow">
          <ChevronRight size={20} />
        </div>
      </div>

      <div className="device-inventory-card-footer">
        <div className="device-inventory-card-stats">
          <div className="device-inventory-card-stat">
            <span className="stat-label">Seleccionados:</span>
            <span className={`stat-value ${hasSelection ? 'active' : ''}`}>
              {selectedCount}
              {maxSelection !== undefined && ` / ${maxSelection}`}
            </span>
          </div>
          <div className="device-inventory-card-stat">
            <span className="stat-label">Disponibles:</span>
            <span className="stat-value">{totalAvailable}</span>
          </div>
        </div>
        
        {isMaxed && (
          <div className="device-inventory-card-badge badge-warning">
            Máximo alcanzado
          </div>
        )}
        {hasSelection && !isMaxed && (
          <div className="device-inventory-card-badge badge-success">
            {selectedCount} seleccionado{selectedCount !== 1 ? 's' : ''}
          </div>
        )}
      </div>
    </div>
  );
};

export default DeviceInventoryCard;
